import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { Notification } from '../../../../common/notification'
import { Panel } from '../../../../common/panel'
import { panelTypes } from '../../../../common/panel/constants'
import { SCREEN } from '../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../common/selectCurrencyUnit/useFormatCurrency'
import { RANK_BY } from './constant'
import { RightHeader } from './RightHeader'
import {
  resetStore,
  selectData,
  selectRankBy,
  selectTopCompany,
  selectTopYears,
  selectYear,
} from './store/slice'
import { downloadTopPlayers } from './store/thunk'
import TableContent from './TopPlayerTable'

export const TopIndustryPlayers = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const { currency, multiplier, unitName } = useFormatCurrency(
    SCREEN.INDUSTRY_OVERVIEW,
  )

  const topYears = useSelector(selectTopYears)
  const topCompany = useSelector(selectTopCompany)
  const year = useSelector(selectYear)
  const data = useSelector(selectData)
  const rankBy = useSelector(selectRankBy)

  const params = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })

  useEffect(() => {
    return () => {
      dispatch(resetStore())
    }
  }, [])

  const renderContent = () => {
    if (!Object.keys(topYears).length) {
      return <Notification />
    }

    return <TableContent />
  }

  return (
    <Panel
      isI18n
      height={366}
      label="industryOverview.topIndustryPlayers.TOP_INDUSTRY_PLAYERS"
      downloadCsv={{
        disabled: !Object.keys(data).length,
        downloadFunc: () =>
          downloadTopPlayers({
            organizationId: params.organizationId,
            top: topCompany.value,
            year: year.value,
            sortByAssets: rankBy.value === RANK_BY.totalAssets.value,
            sortByRevenue: rankBy.value === RANK_BY.netRevenue.value,
            currency,
            currencyUnit: {
              multiplier,
              value: unitName,
            },
          }),
      }}
      type={panelTypes.HALF_SIZE}
      renderRightHeader={() => <RightHeader />}
    >
      {renderContent()}
    </Panel>
  )
}
